/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchShiftChangeProposals} from '../api'

export const useMutationSearchShiftChangeProposals = createReactQueryMutationHook('searchShiftChangeProposals', searchShiftChangeProposals)
